import type { IResourceForEdit } from '@/types/Data'
import type { ICloneResource, ICreateResource, IUpdateResource } from '@/types/Request'
import BaseService from '../BaseService'

export default class ResourceServices extends BaseService {
  GetResourceList(LanguageId: string) {
    return this.GET<Record<string, string>>(this.PATHS.GET_RESOURCE_LIST, {
      LanguageId,
      prefix: 'admin',
    })
  }

  GetResourceForEdit() {
    return this.GET<IResourceForEdit[]>(this.PATHS.GET_RESOURCE_FOR_EDIT)
  }

  SetResourceValue(data: IUpdateResource) {
    return this.POST<void>(this.PATHS.SET_RESOURCE_VALUE, data)
  }

  CloneResource(data: ICloneResource) {
    return this.POST<string>(this.PATHS.CLONE_RESOURCE, data)
  }

  CreateResource(data: ICreateResource) {
    return this.POST<boolean>(this.PATHS.CREATE_RESOURCE, data)
  }
}
